export enum ActionOperators {
  Decrement = '-1',
  Increment = '1',
}
